import { render, staticRenderFns } from "./getCard.vue?vue&type=template&id=14a836a0&scoped=true&"
import script from "./getCard.vue?vue&type=script&lang=js&"
export * from "./getCard.vue?vue&type=script&lang=js&"
import style0 from "./getCard.vue?vue&type=style&index=0&id=14a836a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a836a0",
  null
  
)

export default component.exports